var exports = {
  "zr": "AudioWaveform.module__root___Y1VFcG",
  "Ji": "AudioWaveform.module__canvas___Y1VFcG",
  "r1": "AudioWaveform.module__selection___Y1VFcG",
  "EP": "AudioWaveform.module__selectionDragging___Y1VFcG",
  "p$": "AudioWaveform.module__handle___Y1VFcG",
  "lG": "AudioWaveform.module__playhead___Y1VFcG",
};

module.exports = exports;
